import { PrecisionType } from "@shared/types";
import { useContext } from "react";
import { PrecisionsDataContext } from "@shared/features/common/PrecisionsData.context";

export const usePrecisions = (args?: {
  symbol?: string;
  exchange?: string;
  precisionType: PrecisionType;
}) => {
  const precisionsData = useContext(PrecisionsDataContext)!;

  return {
    ...precisionsData,
    precision: args
      ? precisionsData.getPrecision(
          args.precisionType,
          args.symbol,
          args.exchange
        )
      : 0,
  };
};
